import type { ReactNode } from 'react';

export const symbol_av_timer: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M339.5-148.5q-65.5-28.5-114-77t-77-114Q120-405 120-480t30.5-142Q181-689 235-738q11-10 25-13t24 7l228 228q9 9 9 21t-9 21q-9 9-21.5 9t-21.5-9L261-682q-39 42-60 93.5T180-480q0 125 87.5 212.5T480-180q125 0 212.5-87.5T780-480q0-118-79-204.5T504-779v70q0 13-8.5 21.5T474-679q-13 0-21.5-8.5T444-709v-101q0-13 8.5-21.5T474-840q75 0 141.5 28.5t116.5 77q50 48.5 79 114T840-480q0 75-28.5 140.5t-77 114q-48.5 48.5-114 77T480-120q-75 0-140.5-28.5ZM233-455q-11-11-11-27t11-27q11-11 27-11t27 11q11 11 11 27t-11 27q-11 11-27 11t-27-11Zm218 221q-11-11-11-27t11-27q11-11 27-11t27 11q11 11 11 27t-11 27q-11 11-27 11t-27-11Zm221-221q-11-11-11-27t11-27q11-11 27-11t27 11q11 11 11 27t-11 27q-11 11-27 11t-27-11Z"
		/>
	</svg>
);
